import { dateFormatConDiaYHoraShort, getDate } from "./DateFunctions";
export class JsonFormatExcel {

    plan_consolidacion(jsons) {
        let newj = [];
        for (let i = 0; i < jsons.length; i++) {
            let dias = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
            let new_info = {
                Bloque: jsons[i].bloque,
                "Sem. siembra": jsons[i].semana_siembra,
                "Sem.consolidacion": jsons[i].semana_actual,
                "Ssem. transplante": jsons[i].transplante,
                "Total plantado": jsons[i].total_ejecutado_charolas,
                "Total plan": this.totales_bloque(jsons[i])[0],
                "Total ejecutado": this.totales_bloque(jsons[i])[1],
            };

            for (let j = 0; j < dias.length; j++) {
                new_info[`${dias[j]} plantado`] = jsons[i][dias[j]];
                new_info[`${dias[j]} plan`] = jsons[i][dias[j] + "p"];
                new_info[`${dias[j]} ejecutado`] = jsons[i][dias[j] + "e"];
            }
            newj.push(new_info);
        }
        newj.push({ "Bloque": "Creado: " + dateFormatConDiaYHoraShort(getDate()) })
        return newj;
    }

    aclimatacion(jsons) {
        let newj = [];
        for (let i = 0; i < jsons.length; i++) {
            let dias = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
            let new_info = {
                Bloque: jsons[i].bloque,
                "Sem. siembra": jsons[i].semana_siembra,
                "Sem.consolidacion": jsons[i].semana_actual,
                "Sem. transplante": jsons[i].transplante,
                "Total plantado": jsons[i].total_ejecutado_charolas,
                "Total plan": this.totales_bloque(jsons[i])[0],
                "Total ejecutado": this.totales_bloque(jsons[i])[1],
                "En aclimatación desde": dateFormatConDiaYHoraShort(jsons[i].aclimatado),
                "Usuario edición": jsons[i].usuario_acl
            };
            newj.push(new_info);
        }
        return newj;
    }

    totales_bloque = (dt) => {
        let dias = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
        let total_plan = 0;
        let total_ejecutado = 0;
        for (let i = 0; i < dias.length; i++) {
            total_plan += dt[`${dias[i]}p`];
            total_ejecutado += dt[`${dias[i]}e`];
        }
        return [total_plan, total_ejecutado];
    }

}